<div class="visualizar-arquivo-container">
  <!-- Close Button -->
  <button class="close-btn" (click)="onFecharClick()" title="Fechar">
    <i class="fa fa-times"></i>
  </button>

  <!-- Content based on file type -->
  <div class="arquivo-content">
    <!-- Loading Spinner -->
    <div *ngIf="isLoading" class="loading-spinner">
      <div class="spinner"></div>
      <p>Carregando arquivo...</p>
    </div>

    <!-- Error Message -->
    <div *ngIf="loadError && !isLoading" class="load-error">
      <i class="fa fa-exclamation-triangle"></i>
      <p>Erro ao carregar o arquivo</p>
      <p class="file-name">{{ arquivo.nome }}</p>
    </div>

    <!-- Image -->
    <img *ngIf="!isLoading && !loadError && isImage()" [src]="getDataUrl()" [alt]="arquivo.nome" class="arquivo-media" />

    <!-- Video -->
    <video *ngIf="!isLoading && !loadError && isVideo()" controls class="arquivo-media">
      <source [src]="getDataUrl()" [type]="getMimeType()" />
      Seu navegador não suporta a tag de vídeo.
    </video>

    <!-- Audio -->
    <audio *ngIf="!isLoading && !loadError && isAudio()" controls class="arquivo-media">
      <source [src]="getDataUrl()" [type]="getMimeType()" />
      Seu navegador não suporta a tag de áudio.
    </audio>

    <!-- PDF -->
    <iframe *ngIf="!isLoading && !loadError && isPdf()" [src]="getResourceUrl()" class="arquivo-media pdf-viewer"></iframe>

    <!-- Unknown/Unsupported -->
    <div *ngIf="!isLoading && !loadError && getFileType() === 'unknown'" class="unsupported-file">
      <i class="fa fa-file"></i>
      <p>Arquivo não suportado para visualização</p>
      <p class="file-name">{{ arquivo.nome }}</p>
    </div>
  </div>

  <!-- File Info -->
  <div class="arquivo-info">
    <p class="arquivo-nome">{{ arquivo.nome }}</p>
    <p class="arquivo-data">{{ arquivo.dataOperacao | date:'dd/MM/yyyy HH:mm' }}</p>
  </div>
</div>
